import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUsersService } from "services/UsersService";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  UserSelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const userSelectSlice = createSlice({
  name: "userSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getUserSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getUserSelectModels.fulfilled, (state, action) => {
        state.UserSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getUserSelectModels = createAsyncThunk("Users/GetSelectModels", async () => {
  const usersService = container.get<IUsersService>(SERVICE_TYPES.UsersService);
  return await usersService.getSelectModels();
});

export const selectUserSelectModels = (state: RootState) => {
  return state.userSelect.UserSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.userSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.userSelect.LastUpdateTime;
};

export default userSelectSlice.reducer;
